import React from 'react';
import { PageTitle, PostItem, PostsListContainer, Seo } from '../components/ui';
import lang from '../assets/lang';

export const Blog = () => {

	const getPosts = () =>
		lang.posts.map(post =>
			<PostItem
				key={post.title}
				title={post.title}
				text={post.text.slice(0, 200)}
				image={post.image}
				author={post.author}
				authorImage={post.authorImage}
				link={post.link} />
		);

	return (
		<div>
			<Seo
				pageTitle={lang.blogSeo.pageTitle}
				metaDescription={lang.blogSeo.metaDescription}
				metaKeywords={lang.blogSeo.metaKeywords}
			/>
			<PageTitle
				title={lang.titleBlog}
				text={lang.textBlog} />

			<PostsListContainer>
				{getPosts()}
			</PostsListContainer>
		</div>
	);
};



// WEBPACK FOOTER //
// ./src/pages/Blog.js